module.exports = __webpack_public_path__ + "img/rep-palomba.f21d5aa8.jpg";